const jsonLD = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": []
};

for (const faq of faqData) {
  jsonLD.mainEntity.push({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  });
}

// JSON-LDスクリプトを生成します。
const script = document.createElement('script');
script.type = 'application/ld+json';
script.text = JSON.stringify(jsonLD);

// スクリプトを<head>要素に追加します。
document.getElementsByTagName('head')[0].appendChild(script);
